var Survey = {
	lock: false,
	init: function (id) {
		$('#survey_form').submit(function (e) {
			e.preventDefault();
			if (!Survey.lock) {
				Survey.lock = true;
				Api.post('/survey/submit', {
					survey_id:  id,
					token_survey: $('#secret_token_survey').val(),
					token_question: $('#secret_token_question').val(),
					answer: $('#survey_answer').attr('disabled', true).val()
				}, function(r) {
					if(r.success) {
						Alert.push([{
							type: 'success',
							text: 'Tu participación ha sido añadida con éxito. ¡Suerte!',
							icon: 'check'
						}]);
						//$('#survey').remove();
						document.getElementById("survey").remove();
					} else {
						switch(r.error.identifier){
							case 'empty/surveyId':
								Alert.push([{
									type: 'danger',
									text: '¡Oops! No has seleccionado ninguna encuesta.',
									icon: 'triangle-alert'
								}]);
								break;
							case 'empty/tokens':
								Alert.push([{
									type: 'danger',
									text: '¡Oops! Ha ocurrido un error con la validación.',
									icon: 'triangle-alert'
								}]);
								break;
							case 'token_survey_not_allowed':
								Alert.push([{
									type: 'danger',
									text: '¡Oops! Ha ocurrido un error con la validación.',
									icon: 'triangle-alert'
								}]);
								break;
							case 'token_question_not_exists':
								Alert.push([{
									type: 'danger',
									text: '¡Oops! Ha ocurrido un error con la validación.',
									icon: 'triangle-alert'
								}]);
								break;
							case 'token_error_survey_validation':
								Alert.push([{
									type: 'danger',
									text: '¡Oops! Ha ocurrido un error con la validación.',
									icon: 'triangle-alert'
								}]);
								break;
							case 'empty/answer':
								Alert.push([{
									type: 'danger',
									text: '¡Oops! No ingresado ninguna respuesta.',
									icon: 'triangle-alert'
								}]);
								break;
							case 'survey_id_not_found':
								Alert.push([{
									type: 'danger',
									text: '¡Oops! La encuesta que intentas responder no existe.',
									icon: 'triangle-alert'
								}]);
								document.getElementById("survey").remove();
								break;
							case 'survey_is_not_enabled':
								Alert.push([{
									type: 'danger',
									text: '¡Oops! La encuesta que intentas responder no está disponible.',
									icon: 'triangle-alert'
								}]);
								$('#survey').remove();
								break;
							case 'already_participation_send':
								Alert.push([{
									type: 'danger',
									text: '¡Oops! Ya has participado en esta encuesta.',
									icon: 'triangle-alert'
								}]);
								document.getElementById("survey").remove();
								break;
						}
					}
					$('#survey_answer').attr('disabled', false);
					Survey.lock = false;
				});
			}
		});
	}
}
